// Staff preview of a page/product/article whose Live switch is off (?off_preview=1).
const staffToken = () => localStorage.getItem("rhm_token");

export const isOffPreview = () =>
    typeof window !== "undefined"
    && new URLSearchParams(window.location.search).get("off_preview") === "1";

export const offPreviewRequest = () => (isOffPreview()
    ? {
        params: { preview: 1 },
        headers: staffToken() ? { Authorization: `Bearer ${staffToken()}` } : {},
    }
    : {});

export const offPreviewQuery = () => (isOffPreview() ? "?preview=1" : "");

export const offPreviewFetchInit = () => (isOffPreview() && staffToken()
    ? { headers: { Authorization: `Bearer ${staffToken()}` } }
    : {});

export const offReason = (error) => error?.response?.data?.detail || error?.message || "";
